import { FormlyFieldConfig } from "@ngx-formly/core";
import { Injector } from "@angular/core";
import { FieldDefinitionFields } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-fields";
import { FieldDefinitionConditions } from "../../../../../../sections/medicinalProduct/message/fieldDefinition-conditions";
import { EntityEnum } from "../../../EntityEnum";
import { MedicinalProductsQueryNode } from "../../MedicinalProductsQueryNode";
import { Art57Section } from "../../../../Art57Section/Art57Section";
import { TreeNodeOrganisationList } from "../../../Art57Node/ListEntity/TreeNodeOrganisationList";
import { AutoUploadEntityEnum as AutoUploadEntityEnum } from "../../../../AutoUploadEntityEnum";

export class MAHsQueryNode extends MedicinalProductsQueryNode {
    constructor(injector: Injector) {
    const queryFields: FormlyFieldConfig[] =  new FieldDefinitionFields(injector).mahsFields;
    const createChidTemplateParams = {nodeType: 1};
    const queryConditions: FormlyFieldConfig[] = new FieldDefinitionConditions(injector).mahsConditions;
       super(injector, [], 'MAHs', EntityEnum.mah,  queryFields, queryConditions,injector.get(Art57Section).medicinalProduct.mahsTreeNode,TreeNodeOrganisationList,AutoUploadEntityEnum.mah, createChidTemplateParams);       
    }
}